<div>
  <p>Deseja inativar o e-mail <strong>{{ email }}</strong>? Ele deixará de ser usado para envio de mailling e
    notificações.</p>
  <form [formGroup]="justificativaForm" id="justificativaForm">
    <div class="form-group">
      <label for="justificativa" class="form-label required">Justificativa</label>
      <textarea nz-input formControlName="justificativa" id="justificativa" rows="3" [maxlength]="500"
        placeholder="Explique o motivo da inativação"></textarea>
    </div>
  </form>
  <div class="row mt-4">
    <div class="col-12 d-flex justify-content-end">
      <button nz-button nzType="primary" nzDanger (click)="handleOk()">Inativar</button>
      <button nz-button nzType="default" class="ms-2" (click)="handleCancel()">Cancelar</button>
    </div>
  </div>
</div>
